import Pagination from "./api/PageRequest";

export const parsePagination = (search: string): Pagination => {
    const params = new URLSearchParams(search);
    const pageNo = parseInt(params.get("page") || "0");
    const pageSize = parseInt(params.get("size") || "10");
    return { page: pageNo, size: pageSize };
  };